import {
  COLORS,
  Drawer,
  GenericIconName,
  HeaderButton,
} from '@aboutyou/ui-components';
import React from 'react';
import {useIsCouponWalletActive} from '../hooks/useIsCouponWalletActive';
import {useGetCouponsCount} from '../hooks/useGetCouponsCount';
import {useSelectedDiscountColor} from '../../../../backend-services/Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {CouponWallet} from '../CouponWallet';
import {useCouponWalletStateManager} from '../hooks/useCouponWalletStateManager';
import {useTrackCouponWalletEntryPoint} from '../hooks/useTrackCouponWalletEntryPoint';
import {useShowNewCouponsNotificationBadge} from '../hooks/useShowNewCouponsNotificationBadge';

export const HeaderCouponWalletButton = () => {
  const isCouponWalletActive = useIsCouponWalletActive();
  const couponsCount = useGetCouponsCount();
  const selectedDiscountColor = useSelectedDiscountColor();
  const {open} = useCouponWalletStateManager();
  const {featureImpressionRef, trackFeatureClick} =
    useTrackCouponWalletEntryPoint();
  const {showNewCouponsNotificationBadge, setCouponWalletWasOpened} =
    useShowNewCouponsNotificationBadge(couponsCount);

  if (!isCouponWalletActive) {
    return null;
  }

  const handleOnClick = () => {
    trackFeatureClick();
    open();
    setCouponWalletWasOpened();
  };

  return (
    <>
      <HeaderButton
        data-testid="HeaderCouponWalletButton"
        asset={GenericIconName.Coupon}
        iconSize="S"
        badgeColor={selectedDiscountColor || COLORS.RedSale}
        count={showNewCouponsNotificationBadge ? couponsCount : 0}
        badgeOffset={{
          right: 0,
          top: 2,
        }}
        showBadge={showNewCouponsNotificationBadge}
        onClick={handleOnClick}
        ref={featureImpressionRef}
      />
      <CouponWallet ContentPopperLayoutComponent={Drawer} />
    </>
  );
};
